import * as THREE from 'three';
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js';
import { downloadFile } from './downloadFile';

/** Exports the given mesh as a binary .stl file, ready for CNC/3D-print tooling. */
export function exportSTL(mesh: THREE.Object3D, fileName: string): void {
  const exporter = new STLExporter();
  const result = exporter.parse(mesh, { binary: true }) as unknown as DataView;
  downloadFile(result.buffer as ArrayBuffer, fileName, 'model/stl');
}
